/*
 * <pb-add-to-cart>: envolve um <form action="/cart/add"> e adiciona via AJAX, abrindo a gaveta do carrinho
 * (reaproveita cart-drawer.renderContents do Dawn). Sem gaveta na página, o formulário segue o envio normal.
 */
if (!customElements.get('pb-add-to-cart')) {
  customElements.define(
    'pb-add-to-cart',
    class PbAddToCart extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.button = this.querySelector('[type="submit"]');
        if (!this.form || !this.button) return;
        this.onSubmit = this.onSubmit.bind(this);
        this.form.addEventListener('submit', this.onSubmit);
        if (document.querySelector('cart-drawer')) this.button.setAttribute('aria-haspopup', 'dialog');
      }

      disconnectedCallback() {
        this.form?.removeEventListener('submit', this.onSubmit);
      }

      async onSubmit(event) {
        const drawer = document.querySelector('cart-drawer');
        if (!drawer || typeof drawer.renderContents !== 'function') return;
        event.preventDefault();
        if (this.button.getAttribute('aria-busy') === 'true') return;

        this.setBusy(true);
        this.clearError();
        const body = new FormData(this.form);
        body.append('sections', 'cart-drawer,cart-icon-bubble');
        body.append('sections_url', window.location.pathname);

        try {
          const response = await fetch(`${window.routes.cart_add_url}.js`, {
            method: 'POST',
            headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
            body,
          });
          const data = await response.json();
          if (data.status) {
            this.showError(data.description || data.message);
            return;
          }
          if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pb-add-to-cart', productVariantId: body.get('id'), cartData: data });
          }
          drawer.setActiveElement?.(this.button);
          drawer.classList.remove('is-empty');
          drawer.renderContents(data);
        } catch (error) {
          console.error(error);
          this.form.removeEventListener('submit', this.onSubmit);
          this.form.submit();
        } finally {
          this.setBusy(false);
        }
      }

      setBusy(busy) {
        if (busy) this.button.setAttribute('aria-busy', 'true');
        else this.button.removeAttribute('aria-busy');
        this.button.classList.toggle('is-loading', busy);
      }

      showError(message) {
        let el = this.querySelector('.pb-atc-error');
        if (!el) {
          el = document.createElement('p');
          el.className = 'pb-atc-error';
          el.setAttribute('role', 'alert');
          this.append(el);
        }
        el.textContent = message;
      }

      clearError() {
        this.querySelector('.pb-atc-error')?.remove();
      }
    }
  );
}

/*
 * <pb-gift-sync data-expected="Adrenaline" data-current="...">: grava no carrinho o brinde da faixa atingida
 * (atributo "Brinde a separar", visível no pedido para o despacho). Roda sempre que a sacola é renderizada de novo.
 */
if (!customElements.get('pb-gift-sync')) {
  customElements.define(
    'pb-gift-sync',
    class PbGiftSync extends HTMLElement {
      connectedCallback() {
        const expected = this.dataset.expected || '';
        if (expected === (this.dataset.current || '')) return;
        clearTimeout(PbGiftSync.timer);
        PbGiftSync.timer = setTimeout(() => {
          fetch(`${window.routes?.cart_update_url || '/cart/update'}.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: { 'Brinde a separar': expected } }),
          }).catch((error) => console.error(error));
        }, 300);
      }
    }
  );
}

/*
 * Ao mudar quantidade ou remover item, o Dawn redesenha a gaveta e a rolagem voltaria ao topo
 * (onde ficam as promoções). Guarda a posição da lista e a devolve depois do redesenho.
 */
(() => {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
  let lastScroll = 0;
  document.addEventListener(
    'scroll',
    (event) => {
      if (event.target instanceof Element && event.target.matches('cart-drawer-items')) lastScroll = event.target.scrollTop;
    },
    true
  );
  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    if (event.source !== 'cart-items') return;
    const items = document.querySelector('cart-drawer cart-drawer-items');
    if (items) items.scrollTop = lastScroll;
  });
})();
